import { ArrowRight, Sparkles } from "lucide-react";

export default function Hero() {
  const scrollTo = (id) => (e) => {
    e.preventDefault();
    document.querySelector(id)?.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <section id="top" className="relative overflow-hidden" data-testid="hero-section">
      {/* Decorative sun glow */}
      <div className="absolute -top-32 -left-40 h-[520px] w-[520px] sun-glow rounded-full pointer-events-none" />
      <div className="absolute top-40 -right-32 h-[360px] w-[360px] sun-glow rounded-full pointer-events-none" />

      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 pt-16 pb-20 lg:pt-24 lg:pb-32">
        <div className="grid lg:grid-cols-12 gap-10 lg:gap-16 items-center">
          <div className="lg:col-span-7 fade-up">
            <div className="inline-flex items-center gap-2 rounded-full bg-sunlit-cream border border-stone-200/70 px-4 py-1.5 mb-6">
              <Sparkles className="h-3.5 w-3.5 text-sunlit-gold" />
              <span className="text-xs font-medium tracking-wider uppercase text-sunlit-mute">
                Certified Happiness Coach
              </span>
            </div>

            <h1 className="font-serif-display text-5xl sm:text-6xl lg:text-7xl leading-[1.02] tracking-tight text-sunlit-ink">
              Choose Happiness.
              <br />
              <span className="italic text-sunlit-gold">Then practice it.</span>
            </h1>

            <p className="mt-6 text-base sm:text-lg font-sans text-sunlit-mute leading-relaxed max-w-xl">
              I'm <span className="text-sunlit-ink font-medium">Dr. Vrinda Jayaram S</span> — an Assistant Professor of Physiology and a Certified Happiness Coach. I gently guide willing souls to shift from within, so happiness becomes their natural way of being.
            </p>

            <div className="mt-9 flex flex-wrap items-center gap-4">
              <a
                href="#book"
                onClick={scrollTo("#book")}
                className="group inline-flex items-center gap-2 rounded-full bg-sunlit-gold hover:bg-sunlit-gold-hover text-sunlit-ink px-7 py-3.5 text-sm font-medium tracking-wide transition-all shadow-sm hover:shadow-lg hover:-translate-y-0.5"
                data-testid="hero-book-clarity-call-button"
              >
                Book a free clarity call
                <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
              </a>
              <a
                href="#services"
                onClick={scrollTo("#services")}
                className="inline-flex items-center gap-2 rounded-full border border-stone-300 hover:border-sunlit-ink/70 text-sunlit-ink px-7 py-3.5 text-sm font-medium tracking-wide transition-all"
                data-testid="hero-explore-services-button"
              >
                Explore services
              </a>
            </div>

            <div className="mt-12 grid grid-cols-3 gap-6 max-w-md">
              <Stat number="15" label="min clarity call" />
              <Stat number="6" label="day deep journey" />
              <Stat number="∞" label="lasting shifts" />
            </div>
          </div>

          <div className="lg:col-span-5 relative fade-up" style={{ animationDelay: "120ms" }}>
            <div className="relative">
              <div className="absolute -inset-4 bg-sunlit-gold/15 rounded-[2rem] blur-2xl" />
              <div className="relative rounded-[2rem] overflow-hidden border border-stone-200 shadow-xl">
                <img
                  src="https://images.pexels.com/photos/1212600/pexels-photo-1212600.jpeg?auto=compress&cs=tinysrgb&w=1200"
                  alt="Calm seaside at warm golden sunrise"
                  className="w-full h-[520px] object-cover"
                />
                <div className="absolute inset-x-0 bottom-0 h-1/3 bg-gradient-to-t from-sunlit-ink/55 to-transparent" />
                <div className="absolute bottom-5 left-5 right-5">
                  <p className="font-serif-display italic text-2xl text-white leading-snug">
                    "The sun rises inside, first."
                  </p>
                </div>
              </div>

              {/* Floating badge */}
              <div className="absolute -bottom-6 -right-6 hidden sm:block">
                <div className="rounded-2xl bg-sunlit-cream border border-stone-200 px-5 py-4 shadow-lg">
                  <p className="text-xs uppercase tracking-widest text-sunlit-mute">Begin with</p>
                  <p className="font-serif-display text-2xl text-sunlit-ink">A 15-min call</p>
                  <p className="text-xs text-sunlit-gold font-medium mt-1">Complimentary · on Zoom</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

function Stat({ number, label }) {
  return (
    <div>
      <div className="font-serif-display text-4xl text-sunlit-gold leading-none">{number}</div>
      <div className="mt-1.5 text-xs uppercase tracking-wider text-sunlit-mute">{label}</div>
    </div>
  );
}
